const pubnubConfig = () => {
  const data = {
    subscribeKey: process.env.VUE_APP_PUBNUB_SUBSCRIBE_KEY || "",
    uuid: process.env.VUE_APP_PUBNUB_UUID || "",
  };
  return data;
};

const appBarHead = () => {
  return [
    {
      icon: "fal fa-home",
      text: "home",
      to: "/",
      items: [],
    },
    {
      icon: "fal fa-home",
      text: "business_type",
      to: "/",
      items: [
        {
          text: "grocery",
          to: "/grocery",
        },
        {
          text: "cafe",
          to: "/cafe",
        },
        {
          text: "restaurant",
          to: "/restaurant",
        },
        {
          text: "bar",
          to: "/bar",
        },
        {
          text: "retail",
          to: "/retail",
        },
        {
          text: "clothing",
          to: "/clothing",
        },
      ],
    },
    {
      text: "products",
      icon: "fal fa-box",
      to: "/products",
      items: [
        {
          text: "kitchen",
          to: "/products/kitchen-display",
        },
        {
          text: "smart_order",
          to: "/products/smart-order",
        },
        {
          text: "table_management",
          to: "/products/table-management",
        },
        {
          text: "employee_management",
          to: "/products/employee-management",
        },
        {
          text: "inventory_management",
          to: "/products/inventory-management",
        },
        {
          text: "customer_management",
          to: "/products/customer-management",
        },
      ],
    },
    {
      icon: "fal fa-play",
      text: "tutorials",
      to: "/tutorials",
      items: [],
    },
    {
      icon: "fal fa-sign-in-alt",
      text: "login",
      to: "/login",
      items: [],
    },
  ];
};

const TableStatus = (prop) => {
  const data = [
    {
      text: prop.$t("all"),
      value: "all",
    },
    {
      text: prop.$t("pending"),
      value: "pending",
    },
    {
      text: prop.$t("cooking"),
      value: "cooking",
    },
    {
      text: prop.$t("ready"),
      value: "ready",
    },
    {
      text: prop.$t("cancel"),
      value: "cancel",
    },
    {
      text: prop.$t("delivered"),
      value: "delivered",
    },
    {
      text: prop.$t("paid"),
      value: "paid",
    },
  ];
  return data;
};

const OrderStatus = (prop) => {
  const data = [
    {
      text: prop.$t("all"),
      value: null,
    },
    {
      text: prop.$t("pending"),
      value: "pending",
    },
    {
      text: prop.$t("completed"),
      value: "completed",
    },
    {
      text: prop.$t("ready"),
      value: "ready",
    },
    {
      text: prop.$t("decline"),
      value: "decline",
    },
    {
      text: prop.$t("cancel"),
      value: "cancel",
    },
  ];
  return data;
};

const tableStatusList = () => {
  const status_list = [
    { text: "all", value: "" },
    { text: "available", value: "available" },
    { text: "busy", value: "busy" },
    { text: "reserved", value: "reserved" },
  ];
  return status_list;
};
const productSort = () => {
  const status_list = [
    { text: "new_to_old", value: "desc" },

    { text: "old_to_new", value: "asc" },
  ];
  return status_list;
};

const ActionList = () => {
  const actionList = [
    {
      text: "cancel",
      icon: "fal fa-times-circle",
      value: "cancel",
    },
    {
      text: "cooking",
      icon: "fal fa-utensils-alt",
      value: "cooking",
    },
    {
      text: "delivered",
      icon: "fal fa-truck-loading",
      value: "delivered",
    },
  ];
  return actionList;
};

const buffetBillPOS = () => {
  const rawData = localStorage.getItem("user");
  const user = JSON.parse(rawData);
  const store_name = user?.stores?.name ?? "PosSmart";
  const store_logo = user?.stores?.logo ?? "";
  const store_phone = user?.stores?.phone_no ?? "";
  const store_mobile = user?.stores?.mobile_no ?? "";
  const store_address = user?.stores?.address ?? "Vientiane";
  const store_id = user?.stores?.id ?? 1;
  const branch_id = user?.branch_id?.id ?? 1;
  const branch_name = user?.branch_id?.name ?? "";
  const first_name = user?.first_name ?? "Staff";

  const now = new Date();
  const endTime = new Date(now.getTime() + 2 * 60 * 60 * 1000);
  const fmt = (d) =>
    `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;

  return {
    id: 14671,
    code: "BUFFET-DEMO",
    type: "cash",
    payment_data: JSON.stringify({ method: "cash" }),
    order_type: "Dine In",
    created_at: now.toISOString(),
    start_time: fmt(now),
    end_time: fmt(endTime),
    buffet_duration: 120,
    total_price: 1133000,
    currency_id: { id: 1, code: "LAK" },
    table_id: { id: 1, name: "T14" },
    store_id: {
      id: store_id,
      name: store_name,
      logo: store_logo,
      phone_no: store_phone,
      mobile_no: store_mobile,
      address: store_address,
    },
    branch_id: { id: branch_id, name: branch_name },
    user_id: { id: 1, first_name: first_name },
    buffet_plans: [
      {
        buffet_plan_id: 1,
        plan_name: "Buffet ບໍ່ມີຊາບູ",
        unit_price: 550000,
        persons: 2,
        subtotal: 1100000,
      },
    ],
    history: [
      {
        qty: 1,
        price_sale: 25000,
        total_price: 25000,
        product: { name: "ໂຄກ" },
      },
      {
        qty: 2,
        price_sale: 4000,
        total_price: 8000,
        product: { name: "ນ້ຳດື່ມ" },
      },
    ],
  };
};

const billPOS = () => {
  const rawData = localStorage.getItem("user");
  const user = JSON.parse(rawData);
  const first_name = user.first_name;
  const phone_no = user.phone_no;
  const store_name = user?.stores?.name ?? "Possmart";
  const store_phone_no = user?.stores?.phone_no ?? "2054444151";
  const store_mobile_no = user?.stores?.mobile_no ?? "";
  const store_address = user?.stores?.address ?? "Vientiane";
  const store_logo = user?.stores?.logo ?? "https://i.imgur.com/7bI1k1b.png";
  const branch_name = user?.branch_id?.name ?? "Vientiane";
  const branch_phone_no = user?.branch_id?.phone_no ?? "2028492947";
  const data = {
    id: 14670,
    code: "W8AKTJ1WC3LT",
    note: null,
    total_price_buy: 22000,
    total_price_sale: 27000,
    tax_amount: 0,
    total_profit: 5000,
    total_price: 27000,
    total_paid: 18630000,
    total_overdue: 0,
    total_discount: 0,
    status: "done",
    customer_id: {
      id: 339,
      first_name: first_name,
      phone_no: phone_no,
      point: 4350,
      address: "Test Address",
      village_id: 101001,
      logistics_id: 1,
      village: {
        vill_id: 101001,
        vill_name: "Test Village",
        dr_id: 101,
        district: {
          dr_id: 101,
          dr_name: "Test District",
          pr_id: 1,
          province: {
            pr_id: 1,
            pr_name: "Test Province",
          },
        },
      },
      logistics: {
        id: 1,
        name: "Test Logistics",
      },
    },
    type: "cash",
    txn: null,
    created_at: "2026-01-13T13:46:57.000000Z",
    store_id: {
      id: user?.stores?.id ?? 1,
      name: store_name,
      logo: store_logo,
      address: store_address,
      desc: "JX55986888",
      qr: null,
      thb: 690,
      usd: 22000,
      tax: 10,
      tax_include: 0,
      ticket_verification: 0,
      phone_no: store_phone_no,
      mobile_no: store_mobile_no,
    },
    user_id: {
      id: user?.id ?? 2,
      first_name: first_name,
    },
    branch_id: {
      id: 33,
      name: branch_name,
      phone_no: branch_phone_no,
    },
    table_id: null,
    currency_id: {
      id: 1,
      code: "LAK",
      name: "Lao Kip",
      flag: "https://devla.s3.ap-southeast-1.amazonaws.com/flags/lak.svg",
    },
    exchange_rate: 1,
    stamp_card_receipt: {
      program_label: "Coffee Lover",
      current: 7,
      required: 10,
    },
    history_count: 2,
    history: [
      {
        id: 391,
        txn: "W8AKTJ1WC3LT",
        qty: 2,
        pre_stock: 9,
        post_stock: 8,
        price_buy: 10000,
        price_sale: 12000,
        tax_amount: 0,
        discount: 0,
        total_price: 24000,
        status: "done",
        ticket_id: 14670,
        queue_id: null,
        product_id: 6406,
        variation_id: null,
        variation_option_id: null,
        branch_id: 33,
        store_id: 1,
        exchange_rate: 1,
        product_variant_id: 830,
        user_id: 2,
        created_at: "2026-01-13T13:46:57.000000Z",
        updated_at: "2026-01-13T13:46:57.000000Z",
        product: {
          id: 6406,
          name: "iPhone 13",
          code: "202601896",
          img: "",
          category_id: 330,
          currency_id: 2,
          size_id: 148,
          vendor_id: 71,
          is_bundle: 0,
          desc: "128GB",
          category: {
            id: 330,
            la_name: "Apple",
            en_name: "Apple",
          },
          currency: {
            id: 2,
            code: "THB",
          },
          size: {
            id: 148,
            name: "White",
            unit: "amount",
            amount: 0,
          },
          vendor: {
            id: 71,
            name: "Test",
            phone_no: "2028492947",
          },
        },
        product_variant: {
          id: 830,
          sku: "202601896-128GB-RED",
          price: "12000.00",
          product_id: 6406,
          optionValues: {
            Storage: "128GB",
            Color: "Red",
          },
          options: [
            {
              id: 1092,
              product_variant_id: 830,
              product_option_id: 258,
              selected_value: "128GB",
              created_at: "2026-01-13T13:41:02.000000Z",
              updated_at: "2026-01-13T13:41:02.000000Z",
              product_option: {
                id: 258,
                product_id: 6406,
                store_option_id: 46,
                values: ["128GB", "256GB"],
                created_at: "2026-01-13T13:41:02.000000Z",
                updated_at: "2026-01-13T13:41:02.000000Z",
                store_option: {
                  id: 46,
                  name: "Storage",
                },
              },
            },
            {
              id: 1093,
              product_variant_id: 830,
              product_option_id: 259,
              selected_value: "Red",
              created_at: "2026-01-13T13:41:02.000000Z",
              updated_at: "2026-01-13T13:41:02.000000Z",
              product_option: {
                id: 259,
                product_id: 6406,
                store_option_id: 47,
                values: ["Red", "Black"],
                created_at: "2026-01-13T13:41:02.000000Z",
                updated_at: "2026-01-13T13:41:02.000000Z",
                store_option: {
                  id: 47,
                  name: "Color",
                },
              },
            },
          ],
        },
        bundle_stock_logs: [],
      },
      {
        id: 392,
        txn: "W8AKTJ1WC3LT",
        qty: 1,
        pre_stock: 9,
        post_stock: 8,
        price_buy: 12000,
        price_sale: 15000,
        tax_amount: 0,
        discount: 0,
        total_price: 15000,
        status: "done",
        ticket_id: 14670,
        queue_id: null,
        product_id: 6406,
        variation_id: null,
        variation_option_id: null,
        branch_id: 33,
        store_id: 1,
        exchange_rate: 1,
        product_variant_id: 833,
        user_id: 2,
        created_at: "2026-01-13T13:46:57.000000Z",
        updated_at: "2026-01-13T13:46:57.000000Z",
        product: {
          id: 6406,
          name: "mate70",
          code: "202601896",
          img: "",
          category_id: 330,
          currency_id: 2,
          size_id: 148,
          vendor_id: 71,
          is_bundle: 0,
          desc: "161mm*76mm*7",
          category: {
            id: 330,
            la_name: "Huawei",
            en_name: "Huawei",
          },
          currency: {
            id: 2,
            code: "THB",
          },
          size: {
            id: 148,
            name: "White",
            unit: "amount",
            amount: 0,
          },
          vendor: {
            id: 71,
            name: "Test",
            phone_no: "2028492947",
          },
        },
        product_variant: {
          id: 833,
          sku: "202601896-256GB-BLACK",
          price: "15000.00",
          product_id: 6406,
          optionValues: {
            Storage: "256GB",
            Color: "Black",
          },
          options: [
            {
              id: 1098,
              product_variant_id: 833,
              product_option_id: 258,
              selected_value: "256GB",
              created_at: "2026-01-13T13:41:02.000000Z",
              updated_at: "2026-01-13T13:41:02.000000Z",
              product_option: {
                id: 258,
                product_id: 6406,
                store_option_id: 46,
                values: ["128GB", "256GB"],
                created_at: "2026-01-13T13:41:02.000000Z",
                updated_at: "2026-01-13T13:41:02.000000Z",
                store_option: {
                  id: 46,
                  name: "Storage",
                },
              },
            },
            {
              id: 1099,
              product_variant_id: 833,
              product_option_id: 259,
              selected_value: "Black",
              created_at: "2026-01-13T13:41:02.000000Z",
              updated_at: "2026-01-13T13:41:02.000000Z",
              product_option: {
                id: 259,
                product_id: 6406,
                store_option_id: 47,
                values: ["Red", "Black"],
                created_at: "2026-01-13T13:41:02.000000Z",
                updated_at: "2026-01-13T13:41:02.000000Z",
                store_option: {
                  id: 47,
                  name: "Color",
                },
              },
            },
          ],
        },
        bundle_stock_logs: [],
      },
    ],
    product_return: null,
  };
  return data;
};
const billRestaurant = () => {
  return {};
};

const STORE_TYPE = () => {
  return [
    {
      text: "pos",
      value: "POS",
    },
    {
      text: "restaurant",
      value: "RESTAURANT",
    },
    {
      text: "store_type_buffet",
      value: "BUFFET",
    },
  ];
};

const kitchenList = (prop) => {
  return [
    {
      text: prop.$t("cancel"),
      icon: "fal fa-times-circle",
      value: "cancel",
    },
    {
      text: prop.$t("ready"),
      icon: "fal fa-truck-loading",
      value: "ready",
    },
    {
      text: prop.$t("print"),
      icon: "fal fa-print",
      value: "print",
    },
  ];
};

const kitchenItem = (prop) => {
  return [
    {
      text: prop.$t("cancel"),
      icon: "fal fa-times-circle",
      value: "cancel",
    },
    {
      text: prop.$t("ready"),
      icon: "fal fa-truck-loading",
      value: "ready",
    },
  ];
};

const kitchenStatusAction = (prop) => {
  return [
    {
      text: prop.$t("cooking"),
      value: "cooking",
    },
    {
      text: prop.$t("cancel"),
      value: "cancel",
    },
    {
      text: prop.$t("ready"),
      value: "ready",
    },
    {
      text: prop.$t("delivered"),
      value: "delivered",
    },
  ];
};
const ticketStatus = (prop) => {
  return [
    {
      text: prop.$t("all"),
      value: "all",
    },
    {
      text: prop.$t("done"),
      value: "done",
    },
    {
      text: prop.$t("cancel"),
      value: "cancel",
    },
  ];
};

const purchaseStatus = (prop) => {
  return [
    {
      text: prop.$t("all"),
      value: "all",
    },
    {
      text: prop.$t("pending"),
      value: "pending",
    },
    {
      text: prop.$t("approved"),
      value: "approved",
    },
    {
      text: prop.$t("rejected"),
      value: "rejected",
    },
  ];
};

const listSettings = (isActiveQR = false, isPOSStore = false) => {
  const baseItems = [
    {
      text: "store_settings",
      icon: "store",
      value: 0,
      color: "#50C878",
    },
    {
      text: "profile",
      icon: "user",
      value: 1,
      color: "#E91E63",
    },
    {
      text: "package",
      icon: "box-open",
      value: 2,
      color: "#8A2BE2",
    },
    {
      text: "bank_account",
      icon: "university",
      value: 3,
      color: "#FF6347",
    },
    {
      text: "banner",
      icon: "images",
      value: 4,
      color: "#9370DB",
    },
    {
      text: "receipt",
      icon: "receipt",
      value: 5,
      color: "#F08080",
    },
    {
      text: "printers",
      icon: "print",
      value: 6,
      color: "#4CAF50",
    },
  ];

  baseItems.push(
    {
      text: "dark_mode",
      icon: "moon",
      value: isPOSStore ? 8 : 7,
      color: "#607D8B",
    },
    {
      text: "logout",
      icon: "sign-out-alt",
      value: isPOSStore ? 9 : 8,
      color: "#F44336",
    },
  );

  return baseItems;
};

const refundList = (prop) => {
  return [
    {
      text: prop.$t("not_match"),
      value: "not_match",
    },
    {
      text: prop.$t("change_product"),
      value: "change_product",
    },
    {
      text: prop.$t("problem"),
      value: "problem",
    },
    {
      text: prop.$t("other"),
      value: "other",
    },
  ];
};

const servicesList = (prop) => {
  return [
    {
      text: prop.$t("online"),
      icon: "fal fa-shopping-bag",
      desc: prop.$t("online_desc"),
      color: "#4CAF50 ",
    },
    {
      text: prop.$t("restaurant"),
      icon: "fal fa-utensils",
      desc: prop.$t("restaurant_desc"),
      color: "#D32F2F",
    },
    {
      text: prop.$t("coffee"),
      icon: "fal fa-coffee",
      desc: prop.$t("coffee_desc"),
      color: "#795548",
    },
    {
      text: prop.$t("pharmacy"),
      icon: "fal fa-first-aid",
      desc: prop.$t("pharmacy_desc"),
      color: "#2196F3",
    },
    {
      text: prop.$t("computer"),
      icon: "fal fa-laptop",
      desc: prop.$t("computer_desc"),
      color: "#FF5722",
    },
    {
      text: prop.$t("retail"),
      icon: "fal fa-shopping-cart",
      desc: prop.$t("retail_desc"),
      color: "#FFC107",
    },
    {
      text: prop.$t("clothing"),
      icon: "fal fa-tshirt",
      desc: prop.$t("clothing_desc"),
      color: "#9C27B0",
    },
  ];
};

export {
  pubnubConfig,
  billPOS,
  buffetBillPOS,
  STORE_TYPE,
  TableStatus,
  tableStatusList,
  ActionList,
  billRestaurant,
  kitchenList,
  kitchenItem,
  kitchenStatusAction,
  productSort,
  ticketStatus,
  purchaseStatus,
  appBarHead,
  listSettings,
  OrderStatus,
  refundList,
  servicesList,
};
